import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayTypeService } from '../../../services/rest/display-type.service';
import { AuthUtils } from '../../../utils/AuthUtils';
import { PermissionTargetEnum } from '../../../enums/PermissionTargetEnum';
import { InputButtonIconType } from '../../core/button/button.utils';

@Component({
  selector: 'app-display-type-edit',
  templateUrl: './display-type-edit.component.html',
  styleUrls: ['./display-type-edit.component.scss'],
})
export class DisplayTypeEditComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.DISPLAY_TYPE);
  form: FormGroup;
  id: number | null = null;
  loading = false;
  error: string | null = null;

  constructor(
    private fb: FormBuilder,
    private service: DisplayTypeService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = Number(idParam);
      this.load();
    }
  }

  load(): void {
    this.loading = true;
    this.service.getById(this.id!).subscribe(
      (res) => {
        this.form.patchValue(res);
        this.loading = false;
      },
      () => {
        this.error = 'Nicht gefunden';
        this.loading = false;
      }
    );
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const val = this.form.value;
    this.service.update(this.id!, val).subscribe(
      () => this.router.navigate(['/display-type']),
      (err) => (this.error = 'Fehler beim Speichern')
    );
  }

  cancel(): void {
    this.router.navigate(['/display-type']);
  }
}
